<template>
  <div class="dishes-and-ingredients">
    <template v-for="source in sources" :key="source.name">
      <div class="dish-or-ingredient-name">{{ source.name }}</div>
      <div class="dish-or-ingredient-days">
        <Tooltip v-for="(day, index) in source.days" :key="index" :disabled="!day" placement="top">
          <template #trigger>
            <div
              class="dish-or-ingredient-day"
              :class="{active:Boolean(day)}"
              @click="day && emit('day',day)"
            >
              {{ dayShort(index) }}
            </div>
          </template>
          Przejdź do widoku dziennego
        </Tooltip>
      </div>
    </template>
  </div>
</template>
<script lang="ts" setup>
  import { Tooltip } from '@/components/ui'

  import type { Coordinates } from '@/types/Diet'

  import type { ShoppingListSource } from '../../types'

  defineProps<{ dayShort: (index: number) => string; sources: ShoppingListSource[] }>()
  const emit = defineEmits<{ day: [coordinates: Coordinates] }>()
</script>
